import type { IDataSet } from "../types/table.types";
import uuid4 from "../utils/uuid4";

export default class DatasetRowModel {
  private _value: IDataSet = {
    rows: [],
    columns: [],
  }

  constructor(columns: string[], rows?: Record<string, any>[]) {
    this._value.columns = columns;
    if (rows) {
      rows.forEach((row) => this.processRow(row));
    }
  }

  processRow(row: Record<string, any>): void {
    this._value.rows.push({
      key: uuid4(),
      row,
    });
  }

  get value(): IDataSet {
    return this._value;
  }
}